import { fetchAccountsSuccess } from '../../../../actions';
import { accountsApi, ERROR_CODES } from '../../../../services/api';
import { transformAccountFromGW } from '../../../../services/transformers';

export const handleAccountsFetch = async (apiFetch, transformAccount = transformAccountFromGW, pageSize, page = 1) => {
    try {
        const { results, metadata } = await apiFetch();

        const transformedAccounts = results.map(transformAccount);
        const total = metadata.total;
        const hasMore = page * pageSize < total;

        return {
            items: transformedAccounts,
            hasMore,
            total,
        };
    } catch (error) {
        if (error.status === ERROR_CODES.NOT_FOUND || error.status === ERROR_CODES.ABORT) {
            return {
                items: [],
                hasMore: false,
                total: 0,
            };
        }
        throw error;
    }
};

export const fetchAccounts = async (search, pageSize, page = 1, cacheKey, dispatch) => {
    const result = await handleAccountsFetch(
        () => accountsApi.getAccounts(search, page, pageSize, cacheKey),
        transformAccountFromGW,
        pageSize,
        page
    );

    if (dispatch) {
        dispatch(fetchAccountsSuccess(result.items, result.total));
    }
    return result;
};

export const fetchAccountsUnderNetwork = async (
    search,
    pageSize,
    page = 1,
    networkAccountName,
    dimension,
    cacheKey,
    selectedAccount,
    dispatch
) => {
    const result = await handleAccountsFetch(
        () =>
            accountsApi.getAccountsUnderNetwork(
                search,
                page,
                pageSize,
                networkAccountName ?? selectedAccount.accountId,
                dimension,
                cacheKey
            ),
        account => ({
            ...transformAccountFromGW(account),
            isAccountFetched: true,
        }),
        pageSize,
        page
    );
    if (dispatch) {
        dispatch(fetchAccountsSuccess(result.items, result.total));
    }
    return result;
};
